"use strict";

exports.__esModule = true;
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tborder: 0;\n\theight: 1px;\n\tbackground-image: linear-gradient(\n\t\tto right,\n\t\trgba(0, 0, 0, 0),\n\t\trgba(0, 0, 0, 0.2),\n\t\trgba(0, 0, 0, 0)\n\t);\n\twidth: 85%;\n\tmargin: auto;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

var HR = _styledComponents.default.hr(_templateObject());

HR.displayName = 'HR';
/* @component */

var _default = HR;
exports.default = _default;